import type { ComponentType } from 'react';

import { Portal } from '@skyscanner/backpack-web/bpk-react-utils';
import { withScrim } from '@skyscanner/backpack-web/bpk-scrim-utils';

import withStackingContextReset from './withStackingContextReset';

import type { ChipClick } from '../../types';

import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';
import displayName from '@shared/utils-frontend/display-name';

type Props = {
  isOpen: boolean;
  onClose?: Function | ChipClick;
  containerClassName?: string;
  neverCloseFromPortal?: boolean;
  [key: string]: any;
};

const withScrimmedPortal = <P extends object>(
  WrappedComponent: ComponentType<P>,
) => {
  const Scrimmed = withScrim(withStackingContextReset(WrappedComponent));

  const component = ({
    containerClassName,
    isOpen,
    neverCloseFromPortal,
    onClose,
    ...rest
  }: Props) => (
    <Portal
      isOpen={isOpen}
      onClose={!neverCloseFromPortal ? onClose : () => {}} // To avoid unexpected close event in case multiple modals.
      target={getApplicationElement}
      closeOnEscPressed
    >
      <Scrimmed
        onClose={onClose}
        getApplicationElement={getApplicationElement}
        dark
        containerClassName={containerClassName}
        {...rest}
      />
    </Portal>
  );

  component.displayName = displayName(WrappedComponent);

  return component;
};

export default withScrimmedPortal;
